<ul class="instruction-steps">
	<li data-e2e-documents-upload-confirming-instructions-1>
		{{ 'document-upload-confirming-instructions.DocumentTemplateInstructionsInfoText1' | translate }}
	</li>
	<li>
		<span data-e2e-documents-upload-confirming-instructions-2>
			{{ 'document-upload-confirming-instructions.DocumentTemplateInstructionsInfoText2' | translate }}
		</span>
	</li>
	<li>
		<span data-e2e-documents-upload-confirming-instructions-3>
			{{ 'document-upload-confirming-instructions.DocumentTemplateInstructionsInfoText3' | translate }}
		</span>
	</li>
	<li>
		<span data-e2e-documents-upload-confirming-instructions-4>
			{{ 'document-upload-confirming-instructions.DocumentTemplateInstructionsInfoText4' | translate }}
		</span>
	</li>
	<li>
		<span data-e2e-documents-upload-confirming-instructions-5>
			{{ 'document-upload-confirming-instructions.DocumentTemplateInstructionsInfoText5' | translate }}
		</span>
	</li>
</ul>

<ul class="data-information">
	<li>
		<strong>{{ 'DocumentRecordsColumnTypeCode' | translate: 'DocumentRecordsUploadExcelTemplate' }} </strong> -
		<span data-e2e-documents-upload-confirming-instructions-type>
			{{ 'document-upload-confirming-instructions.DocumentTemplateInstructionsInfoType' | translate }}
		</span>
	</li>
	<li>
		<strong>{{ 'DocumentRecordsColumnNumberCode' | translate: 'DocumentRecordsUploadExcelTemplate' }} </strong> -
		<span data-e2e-documents-upload-confirming-instructions-number>
			{{ 'document-upload-confirming-instructions.DocumentTemplateInstructionsInfoNumber' | translate }}
		</span>
	</li>
	<li>
		<strong>{{ 'DocumentRecordsColumnTotalCode' | translate: 'DocumentRecordsUploadExcelTemplate' }} </strong> -
		<span data-e2e-documents-upload-confirming-instructions-total>
			{{ 'document-upload-confirming-instructions.DocumentTemplateInstructionsInfoTotal' | translate }}
		</span>
	</li>
	<li>
		<strong>{{ 'DocumentRecordsColumnCurrencyCode' | translate: 'DocumentRecordsUploadExcelTemplate' }} </strong> -
		<span data-e2e-documents-upload-confirming-instructions-currency>
			{{ 'document-upload-confirming-instructions.DocumentTemplateInstructionsInfoCurrency' | translate }}
		</span>
	</li>
	<li>
		<strong>{{ 'DocumentRecordsColumnIssueDateCode' | translate: 'DocumentRecordsUploadExcelTemplate' }} </strong> -
		<span data-e2e-documents-upload-confirming-instructions-issued-date>
			{{ 'document-upload-confirming-instructions.DocumentTemplateInstructionsInfoIssueDate' | translate }}
		</span>
	</li>
	<li>
		<strong>{{ 'DocumentRecordsColumnDueDateCode' | translate: 'DocumentRecordsUploadExcelTemplate' }} </strong> -
		<span data-e2e-documents-upload-confirming-instructions-due-date>
			{{ 'document-upload-confirming-instructions.DocumentTemplateInstructionsInfoDueDate' | translate }}
		</span>
	</li>
	<li>
		<strong>{{ 'DocumentRecordsColumnBuyerPaymentDateCode' | translate: 'DocumentRecordsUploadExcelTemplate' }} </strong>
		-
		<span data-e2e-documents-upload-confirming-instructions-payment-date>
			{{ 'document-upload-confirming-instructions.DocumentTemplateInstructionsInfoBuyerPaymentDate' | translate }}
		</span>
	</li>
	<li>
		<strong>{{ 'DocumentRecordsColumnBuyerCountryCodeCode' | translate: 'DocumentRecordsUploadExcelTemplate' }} </strong>
		-
		<span data-e2e-documents-upload-confirming-instructions-buyer-country-code>
			{{ 'document-upload-confirming-instructions.DocumentTemplateInstructionsInfoBuyerCountryCode' | translate }}
		</span>
	</li>
	<li>
		<strong>{{ 'DocumentRecordsColumnBuyerVatNumberCode' | translate: 'DocumentRecordsUploadExcelTemplate' }} </strong>
		-
		<span data-e2e-documents-upload-confirming-instructions-buyer-vat-number>
			{{ 'document-upload-confirming-instructions.DocumentTemplateInstructionsInfoBuyerVatNumber' | translate }}
		</span>
	</li>
	<li>
		<strong>{{ 'DocumentRecordsColumnSupplierCountryCodeCode' | translate: 'DocumentRecordsUploadExcelTemplate' }} </strong>
		-
		<span data-e2e-documents-upload-confirming-instructions-supplier-country-code>
			{{ 'document-upload-confirming-instructions.DocumentTemplateInstructionsInfoSupplierCountryCode' | translate }}
		</span>
	</li>
	<li>
		<strong>{{ 'DocumentRecordsColumnSupplierVatNumberCode' | translate: 'DocumentRecordsUploadExcelTemplate' }} </strong>
		-
		<span data-e2e-documents-upload-confirming-instructions-supplier-vat-number>
			{{ 'document-upload-confirming-instructions.DocumentTemplateInstructionsInfoSupplierVatNumber' | translate }}
		</span>
	</li>
</ul>
